import React from 'react'
import AnnotationCommentListItem from './AnnotationCommentListItem'

class AnnotationCommentList extends React.Component {
  scroll() {
    $('.messages').scrollTop($('.messages')[0].scrollHeight);
  }

  componentDidMount() {
    this.scroll();
  }

  componentDidUpdate(){
    this.scroll();
  }

  render() {
    const emptyMessages = <div className="text-center py-9 grey-text text-lighten-1 px-4"><h1>Leave a comment to get started...</h1></div>

    const messages = this.props.messages.length ? this.props.messages.map((msg) => {
      return <AnnotationCommentListItem klass={this.props.klass} message={msg} key={msg.id} roleType={this.props.roleType} annotation={this.props.annotation} />
    }) : emptyMessages
    return (
      <div className="messages card-block">
        <div className='list-group list-group-borderless'>
          {messages}
        </div>
      </div>
      )
  }
}

export default AnnotationCommentList
